export default class BgLayer {

    private bg: HTMLElement;

    private isHidden: boolean = true;

    constructor(parent: HTMLElement) {

        this.bg = document.createElement("div");
        this.bg.classList.add("mx-bg-layer");
        this.bg.id = "mxBgLayer";

        parent.appendChild(this.bg)

    }

    getElement(): HTMLElement {
        return this.bg;
    }

    showBg() {
        this.isHidden = false;
        $(this.bg).show();

        setTimeout(() => {
            $(this.bg).css("opacity", 1);
        }, 10);

    }

    hideBg() {
        this.isHidden = true;
        $(this.bg).css("opacity", 0);
        setTimeout(() => {
            this.isHidden && $(this.bg).hide();
        }, 250);
    }


}